import { api } from 'store/api/strapiService';

import { formatViewDate } from 'utils/date';

const postController = api.injectEndpoints({
  endpoints: (build) => ({
    getPosts: build.query({
      query: ({ page, size, postType, ...params }) => ({
        url: '/api/ca-posts',
        params: {
          sort: 'publicationDate:desc',
          'pagination[page]': page,
          'pagination[pageSize]': size,
          'filters[postType]$eq]': postType,
          ...params,
        },
      }),
      transformResponse: (response) => ({
        ...response,
        content: response?.data?.map((item) => ({
          ...item,
          img: item.postImage,
          background: item.backgroundImage,
          date: formatViewDate(new Date(item.publicationDate)),
        })),
      }),
    }),
    getPost: build.query({
      query: (documentId) => ({
        url: `/api/ca-posts/${documentId}`,
      }),
      transformResponse: ({ data }) => ({
        ...data,
        img: data.postImage,
        background: data.backgroundImage,
        date: formatViewDate(new Date(data.publicationDate)),
      }),
    }),
  }),
});

export const { useGetPostsQuery, useGetPostQuery } = postController;
